/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import * as io from 'io-ts';
import { SegmentGroup } from '../SegmentGroup/SegmentGroup.entity';

/**
 * The dxp segment group list entity type.
 */
export type EntitySegmentGroupList = io.TypeOf<typeof SegmentGroupList>;

/**
 * The dxp segment group list entity definition.
 * @export
 */
export const SegmentGroupList = io.record(io.string, SegmentGroup, `SegmentGroupList`);
